<template>
  <div class="cell large-12 xxlarge-6">
    <div class="card">
      <div class="grid-x card-header">
        <div class="cell auto">
          <router-link :to="{ name: 'DashboardPageOppgaver'}">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-task"></use></svg></span> Mine oppgaver
              <span v-if="total !== null" class="opacity-60">({{total}})</span>
            </h3>
          </router-link>
        </div>

        <!-- Brukerlist dropdown -->
        <div class="cell shrink" v-if="this.canSelectBruker">
          <div class="select-container small has-popover" :class="{'popover-active': brukerPopoverActive}" @click="toggleBrukerPopover()">
            <a class="button-select" href="javascript:;">
              <span class="title"><span>{{selectedBruker}}</span></span>
              <!-- <span class="label gray small">495</span>  -->
              <span class="glyph"><svg viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-tiny"></use></svg></span>
            </a>

            <span class="popover select-dropdown-popover align-x-right align-y-bottom large">
              <div class="custom-scrollbar">
                <ul>
                  <li v-for="item in brukerList" :key="item.key" :class="{'active': item.key === selectedBrukerId}">
                    <a href="javascript:;" @click="setBruker(item.key)"><span>{{item.val || item.key}}</span><!-- <span class="label gray small">495</span>--></a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
        <!-- Brukerlist dropdown -->

        <!-- Statuslist dropdown -->
        <div class="cell shrink">
          <div class="select-container small has-popover" :class="{'popover-active': statusPopoverActive}" @click="toggleStatusPopover()">
            <a class="button-select" href="javascript:;">
              <span class="title"><span>{{selectedStatus}}</span></span>
              <!-- <span class="label gray small">495</span>  -->
              <span class="glyph"><svg viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-tiny"></use></svg></span>
            </a>

            <span class="popover select-dropdown-popover align-x-right align-y-bottom small">
              <ul>
                <li v-for="item in statusList" :key="item.key" :class="{'active': item.key === selectedStatusId}">
                  <a href="javascript:;" @click="setStatus(item.key)"><span>{{item.val}}</span><!-- <span class="label gray small">495</span>--></a>
                </li>
              </ul>
            </span>
          </div>
        </div>
        <!-- Statuslist dropdown -->
      </div>

      <table-oppgaver v-on:tableLoaded="tableLoaded" :limit="6" :large="false" :brukerId="selectedBrukerId" :statusId="selectedStatusId" />
    </div>
  </div>
</template>

<script>
import TableOppgaver from './TableOppgaver'

export default {
  name: 'WidgetOppgaver',
  components: {
    TableOppgaver
  },
  props: {
    brukerList: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      statusList: [
        { key: null, val: 'Alle statuser' },
        { key: 'pending', val: 'Ubehandlet' },
        { key: 'in-progress', val: 'Under behandling' },
        { key: 'on-hold', val: 'På vent' },
        { key: 'resolved', val: 'Ferdigbehandlet' }
      ],
      statusPopoverActive: false,
      brukerPopoverActive: false,
      selectedStatusId: null,
      selectedBrukerId: null,
      total: null
    }
  },
  computed: {
    canSelectBruker: function () {
      return this.hasAccess('admin')
    },
    selectedStatus: function () {
      if (this.statusList && this.statusList.length) {
        const found = this.statusList.find(x => x.key === this.selectedStatusId)

        if (found) {
          return found.val || found.key
        }
      }

      return 'Alle statuser'
    },
    selectedBruker: function () {
      if (this.brukerList && this.brukerList.length) {
        const found = this.brukerList.find(x => x.key === this.selectedBrukerId)

        if (found) {
          return found.val || found.key
        }
      }

      return 'Alle kontraktsansvarlige'
    }
  },
  created () {
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.statusPopoverActive = false
        vm.brukerPopoverActive = false
      }
    })

    if (this.canSelectBruker) {
      this.selectedBrukerId = localStorage.dbw_oppgaver_bruker || null
    } else {
      this.selectedBrukerId = null
    }

    this.selectedStatusId = localStorage.dbw_oppgaver_status || null
  },
  methods: {
    tableLoaded: function (data) {
      this.total = data.total
    },
    setStatus: function (itemId) {
      this.selectedStatusId = itemId || null

      if (this.selectedStatusId) {
        localStorage.dbw_oppgaver_status = this.selectedStatusId
      } else {
        localStorage.removeItem('dbw_oppgaver_status')
      }
    },
    setBruker: function (itemId) {
      this.selectedBrukerId = itemId || null
      if (this.selectedBrukerId) {
        localStorage.dbw_oppgaver_bruker = this.selectedBrukerId
      } else {
        localStorage.removeItem('dbw_oppgaver_bruker')
      }
    },
    toggleStatusPopover: function () {
      this.statusPopoverActive = !this.statusPopoverActive
      this.brukerPopoverActive = false
    },
    toggleBrukerPopover: function () {
      this.brukerPopoverActive = !this.brukerPopoverActive
      this.statusPopoverActive = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/WidgetOppgaver.vue